import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [];
